{
  "hero": {
    "eyebrow": "Chi siamo",
    "title": "Costruiamo soluzioni energy-fintech per accelerare",
    "highlight": "la transizione energetica",
    "lede": "Realizziamo prodotti all'avanguardia progettati per gestire la crescente complessità del settore delle energie rinnovabili, rendendolo più efficiente, accessibile e redditizio."
  },
  "milestones": {
    "eyebrow": "Il percorso",
    "heading": "La storia di DEC Energy",
    "founded": {
      "title": "Fondazione dell'azienda a Lugano"
    },
    "venture": {
      "title": "Top 3 startup fintech in Svizzera",
      "source": "per >>venture>>"
    },
    "climate": {
      "month": "Marzo",
      "title": "Top 10 climate software company in Europa",
      "source": "per Energy Tech Challengers"
    },
    "energyFintech": {
      "month": "Ottobre",
      "title": "Migliore strumento fintech per la produzione e consumo di energia rinnovabile",
      "source": "per Fintech Awards Italia"
    }
  },
  "founders": {
    "eyebrow": "Innovazione",
    "heading": "I fondatori",
    "linkedinLabel": "Profilo LinkedIn di {{name}}",
    "photoAlt": "I founder di DEC Energy",
    "roles": ["CEO e Co-Founder", "COO e Co-Founder"]
  },
  "partners": {
    "eyebrow": "Con chi lavoriamo",
    "heading": "Partnership con aziende leader nel settore delle energie rinnovabili e non solo"
  },
  "team": {
    "eyebrow": "Unisciti a noi",
    "heading": "Sei tu la nostra prossima grande assunzione?",
    "body": "Siamo sempre alla ricerca di talenti. Inviaci il tuo CV insieme ad una lettera motivazionale e parliamone.",
    "cta": "Candidati qui",
    "photoAlt": "Il team di DEC Energy"
  },
  "ctaTitle": "Vuoi saperne di più su DEC Energy?",
  "committee": {
    "eyebrow": "Comitato strategico e operativo",
    "heading": "Supportati da esperti del settore",
    "label": "Comitato",
    "linkedinLabel": "Profilo LinkedIn di {{name}}"
  }
}
